import Big from "big.js";

export const isValidNumber = (num) =>
  num !== null && num !== undefined && num !== "" && !isNaN(num);

// totalSales = pump price x volume; fallback to computing it if API does not return it
const getTotalSales = ({ totalSales, redemption, literVolume }) => {
  const sales = isValidNumber(totalSales) ? totalSales : redemption?.totalSales;
  if (isValidNumber(sales)) return Number(sales);
  if (isValidNumber(redemption?.pumpPrice) && isValidNumber(literVolume)) {
    return Number(Big(redemption.pumpPrice).mul(literVolume).round(2));
  }
  return null;
};

// totalUserDiscountPremium: positive = discount, negative = premium
// fallback: totalSales - totalCreditPrice
const getDiscountPremium = ({ totalUserDiscountPremium, redemption, totalSales, totalCredit }) => {
  const value = isValidNumber(totalUserDiscountPremium)
    ? totalUserDiscountPremium
    : redemption?.totalUserDiscountPremium;
  if (isValidNumber(value)) return Number(value);
  if (isValidNumber(totalSales) && isValidNumber(totalCredit)) {
    return Number(Big(totalSales).minus(totalCredit).round(2));
  }
  return null;
};

/**
 * Returns { totalSales, discount, premium } for a station redemption row.
 * discount / premium are positive numbers; the one that does not apply is null.
 */
export const getRedemptionSalesAndDiscount = ({
  totalSales,
  totalUserDiscountPremium,
  totalCreditPrice,
  literVolume,
  redemption,
}) => {
  const sales = getTotalSales({ totalSales, redemption, literVolume });
  const discountPremium = getDiscountPremium({
    totalUserDiscountPremium,
    redemption,
    totalSales: sales,
    totalCredit: totalCreditPrice,
  });
  const hasValue = isValidNumber(discountPremium);
  const isPremium = hasValue && discountPremium < 0;

  return {
    totalSales: sales,
    discount: hasValue && !isPremium ? discountPremium : null,
    premium: isPremium ? Math.abs(discountPremium) : null,
  };
};
